import {
  addToReportCheckboxStore,
  addToReportPaginationStore,
} from '../../../views/AddToRequestReport/hooks/useAddToReportTableData'
import {
  addToServiceReportCheckboxStore,
  addToServiceReportPaginationStore,
} from '../../../views/AddToServiceReports/hooks/useAddToServiceReportTableData'
import {
  createReportCheckboxStore,
  createReportPaginationStore,
} from '../../../views/CreateRequestReport/hooks/useCreateReportTableData'
import {
  createMaintenanceReportCheckboxStore,
  createMaintenanceReportPaginationStore,
} from '../../../views/CreateServiceReports/hooks/useCreateServiceReportTableData'
import { customersCheckboxStore } from '../../../views/Customers/hooks/useCustomerTable'
import { customersPaginationStore } from '../../../views/Customers/hooks/useCustomerTableData'
import { customersFilterStore } from '../../../views/Customers/hooks/useCustomerTableFilters'
import { requestsReportsPaginationStore } from '../../../views/NewReports/hooks/useGetReportTableData'
import requestReportsFilterStore from '../../../views/NewReports/stores/ReportsFilterStore'
import {
  adminRequestsFiltersStore,
  adminRequestsPaginationStore,
} from '../../../views/RequestsManagement/pages/AdminRequestsPage'
import {
  allStatusesCheckboxStore,
  allStatusesFiltersStore,
  allStatusesPaginationStore,
  allStatusesSwitcherStore,
  completeStatusesCheckboxStore,
  completeStatusesFiltersStore,
  completeStatusesPaginationStore,
  completeStatusesSwitcherStore,
  pendingStatusesCheckboxStore,
  pendingStatusesFiltersStore,
  pendingStatusesPaginationStore,
  pendingStatusesSwitcherStore,
  processStatusesCheckboxStore,
  processStatusesFiltersStore,
  processStatusesPaginationStore,
  processStatusesSwitcherStore,
  refusedStatusesCheckboxStore,
  refusedStatusesFiltersStore,
  refusedStatusesPaginationStore,
  refusedStatusesSwitcherStore,
  reportStatusesCheckboxStore,
  reportStatusesFiltersStore,
  reportStatusesPaginationStore,
  reportStatusesSwitcherStore,
} from '../../../views/Service/components/AdminTables/consts/table-stores.data'
import { adminServiceTabStore } from '../../../views/Service/components/AdminTables/stores/AdminServiceTablesStore'
import { maintenanceReportsPaginationStore } from '../../../views/ServiceReports/hooks/useGetServiceReportTableData'
import serviceReportsFilterStore from '../../../views/ServiceReports/stores/ReportsFilterStore'
import {
  singleReportFiltersStore,
  singleReportPaginationStore,
} from '../../../views/SingleRequestReport/components/SingleReportTableFilters'
import { singleMaintenanceReportPaginationStore } from '../../../views/SingleServiceReport/hooks/useSingleServiceReportTableData'
import singleReportsFilterStore from '../../../views/SingleServiceReport/stores/ReportsFilterStore'

export const serviceReportsCb = [
  maintenanceReportsPaginationStore.resetParams,
  maintenanceReportsPaginationStore.resetSelectedRow,
  serviceReportsFilterStore.clear,
]

export const requestsReportsCb = [
  requestsReportsPaginationStore.resetParams,
  requestsReportsPaginationStore.resetSelectedRow,
  requestReportsFilterStore.clear,
]

export const customersCb = [
  customersPaginationStore.resetParams,
  customersPaginationStore.resetSelectedRow,
  customersFilterStore.clear,
  () => customersCheckboxStore.resetAll(true),
]

export const singleServiceReportCb = [
  singleMaintenanceReportPaginationStore.resetParams,
  singleMaintenanceReportPaginationStore.resetSelectedRow,
  singleReportsFilterStore.clear,
]

export const requestTableCb = [
  adminRequestsPaginationStore.resetParams,
  adminRequestsPaginationStore.resetSelectedRow,
  adminRequestsFiltersStore.clear,
]

export const singleRequestReportCb = [
  singleReportPaginationStore.resetParams,
  singleReportPaginationStore.resetSelectedRow,
  singleReportFiltersStore.clear,
]

export const addToServiceReportsCb = [
  addToServiceReportPaginationStore.resetSelectedRow,
  addToServiceReportCheckboxStore.resetAll,
]

export const addToRequestReportsCb = [
  addToReportPaginationStore.resetSelectedRow,
  addToReportCheckboxStore.resetAll,
]

export const createServiceReportCb = [
  createMaintenanceReportPaginationStore.resetSelectedRow,
  createMaintenanceReportCheckboxStore.resetAll,
]

export const createRequestReportCb = [
  createReportPaginationStore.resetSelectedRow,
  createReportCheckboxStore.resetAll,
]

export const serviceCb = [
  adminServiceTabStore.clear,
  //tab 1
  allStatusesPaginationStore.resetParams,
  allStatusesPaginationStore.resetSelectedRow,
  allStatusesCheckboxStore.resetAll,
  allStatusesFiltersStore.clear,
  allStatusesSwitcherStore.clear,
  // tab 2
  pendingStatusesPaginationStore.resetParams,
  pendingStatusesPaginationStore.resetSelectedRow,
  pendingStatusesCheckboxStore.resetAll,
  pendingStatusesFiltersStore.clear,
  pendingStatusesSwitcherStore.clear,
  //tab 3
  processStatusesPaginationStore.resetParams,
  processStatusesPaginationStore.resetSelectedRow,
  processStatusesCheckboxStore.resetAll,
  processStatusesFiltersStore.clear,
  processStatusesSwitcherStore.clear,
  //tab 4
  refusedStatusesPaginationStore.resetParams,
  refusedStatusesPaginationStore.resetSelectedRow,
  refusedStatusesCheckboxStore.resetAll,
  refusedStatusesFiltersStore.clear,
  refusedStatusesSwitcherStore.clear,
  //tab5
  completeStatusesPaginationStore.resetParams,
  completeStatusesPaginationStore.resetSelectedRow,
  completeStatusesCheckboxStore.resetAll,
  completeStatusesFiltersStore.clear,
  completeStatusesSwitcherStore.clear,
  //tab 6
  reportStatusesPaginationStore.resetParams,
  reportStatusesPaginationStore.resetSelectedRow,
  reportStatusesCheckboxStore.resetAll,
  reportStatusesFiltersStore.clear,
  reportStatusesSwitcherStore.clear,
]

export const serviceReportsRts = [
  '/service-reports',
  '/service-reports/:reportId',
  '/service-reports/:reportId/add',
  '/service/:serviceRequestId',
]

export const singleServiceReportRts = [
  '/service-reports/:reportId',
  '/service-reports/:reportId/add',
  '/service/:serviceRequestId',
]

export const requestsReportsRts = [
  '/reports',
  '/reports/:reportId',
  '/reports/:reportId/add',
  '/requests/:requestId',
]

export const singleRequestsReportRts = [
  '/reports/:reportId',
  '/reports/:reportId/add',
  '/requests/:requestId',
]

export const customersRts = [
  '/customers',
  '/customers/:customerId',
  '/service/:serviceRequestId',
  '/requests/:requestId',
]
